import React from 'react'
import { Link } from 'react-router-dom'

export default (
    <>
        <div>
            <h1>Privacy Notice</h1>
        </div>
        <div>
            <p>
                <strong>About this Privacy Notice</strong>
            </p>
            <p>
                We know how important it is for you to understand how we use your personal information. This Privacy
                Notice sets out how and why Geomagical Labs Inc (a wholly owned subsidiary within the Ingka Holding BV
                group of companies, together with its affiliate, IKEA Limited) (&quot;IKEA&quot;, &quot;we,&quot;
                &quot;our,&quot; or &quot;us&quot;) collect, store, processes and uses your personal information when
                you use the Sugarcube app. By using the Sugarcube app you agree to accept the terms of this Privacy
                Notice which is supplemental to the{' '}
                <a
                    href="https://www.ikea.com/us/en/customer-service/privacy-policy/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Privacy Policy
                </a>{' '}
                which is incorporated into, and is subject to, the <Link to="/termsofuse">Terms of Use</Link>.
            </p>
            <p>
                If you do not agree to the Terms of Use, the Privacy Policy or this Privacy Notice, please do not use
                the Sugarcube app.
            </p>
        </div>
        <div>
            <p>
                <strong>1. What personal information do we collect?</strong>
            </p>
            <p>Information you provide to us</p>
            <p>The following information to us when you access the Sugarcube app:</p>
            <ul>
                <li>Full Name,</li>
                <li>Email address,</li>
            </ul>
            <p>Information collected through automated means</p>
            <p>
                We may use automated technology such as cookies and other tracking software to collect personal
                information from your computer system or mobile device. We may collect the following information:
            </p>
            <ul>
                <li>Internet Protocol (IP) address or other device identifier</li>
                <li>Browser type and version</li>
                <li>Time zone setting</li>
                <li>Other portable device information</li>
                <li>
                    With your permission, we may also collect your precise location data. We may also collect the time
                    spent visiting, usage patterns, and the domain name of the website from which you linked to our
                    websites.*
                </li>
            </ul>
            <p>
                *We use this information on an anonymous basis and do not use it to identify any particular user. We do
                not link this data to any other data that we hold about you.
            </p>
            <p>Third parties may also provide us with additional publicly available information about you.</p>
        </div>
        <div>
            <p>
                <strong>2. When do we collect your personal information?</strong>
            </p>
            <p>
                You share personal information with us in various ways. For example, we receive personal information
                when you:
            </p>
            <ul>
                <li>Access the Sugarcube app, our websites or use any of our other mobile apps.</li>
                <li>Interact with us on social media (by mentioning/tagging us or by contacting us directly)</li>
                <li>
                    Interact with our websites, such as when you visit our websites on a device, enable location-based
                    features, or click on sponsored links or third-party advertisements on our websites or on other
                    websites and online services
                </li>
            </ul>
            <p>
                At this time, we do not track our users&apos; personal information over time and across third-party
                websites. We therefore do not respond to browser Do Not Track signals.
            </p>
        </div>
        <div>
            <p>
                <strong>3. How do we use your personal information?</strong>
            </p>
            <p>
                We use your personal information for business purposes: to make our products and services available to
                you; to personalize your shopping experience; to improve our operations; and for security and legal
                reasons.
            </p>
            <p>Some examples of how we use your personal information include:</p>
            <ul>
                <li>Measuring your customer satisfaction</li>
                <li>
                    Analyzing shopping trends through account activity and purchase history to provide you a
                    personalized browsing experience
                </li>
                <li>
                    Allowing you to create a profile on our websites which enables you to purchase IKEA products and
                    services online.
                </li>
                <li>
                    Ensuring that our websites are presented in the most effective and relevant manner for you and your
                    device, including setting default options for you such as language and store location
                </li>
                <li>Conducting checks for fraud or other illegal activity</li>
                <li>Protecting our rights or property (or those of others)</li>
                <li>
                    Fulfilling our legal and compliance-related obligations (such as if we receive a legitimate request
                    from a law enforcement agency)
                </li>
            </ul>
        </div>
        <div>
            <p>
                <strong>4. With whom do we share your personal information?</strong>
            </p>
            <p>We do not sell personal information to third parties.</p>
            <p>
                In order for us to provide our products and services to you, we share some of your personal information
                with IKEA Limited.
            </p>
            <ul>
                <li>
                    We may disclose your personal information to our insurers where we believe that it is required by
                    law or contract
                </li>
                <li>
                    We may share or disclose your personal information with law enforcement agencies or public
                    authorities in order to prevent or detect crime or fraudulent activities, as well as in order to
                    fulfill any legal or regulatory obligations
                </li>
                <li>
                    We may share your personal information to comply with court orders and to exercise and/or defend our
                    legal rights
                </li>
                <li>
                    We may share your personal information in the event we sell or transfer all or a portion of our
                    business or assets
                </li>
                <li>
                    We may use your personal information with your consent or as otherwise permitted or required by law
                </li>
            </ul>
            <p>
                We also disclose non-private, deidentified, aggregate or otherwise non-personal information with third
                parties, including social media companies like Facebook and Twitter, and online advertising companies
                like Google, to deliver targeted advertising about other products and services for marketing purposes.
                You may opt-out of receiving marketing messages by using the opt-out mechanisms and links provided in
                each message.
            </p>
        </div>
        <div>
            <p>
                <strong>5. How do we protect the privacy of children?</strong>
            </p>
            <p>
                We do not knowingly solicit personal data from children or send them requests for personal data. We
                acknowledge that visitors of all ages may use our website, however, we do not intentionally collect
                personal data from those under the age of 18. If you are a parent and become aware that your child has
                provided us with information, please contact us using one of the methods specified below, and we will
                work with you to address this issue.
            </p>
        </div>
        <div>
            <p>
                <strong>6. Your Rights</strong>
            </p>
            <p>
                You have a number of rights relating to your personal data and what happens to it. You are entitled to:
            </p>
            <ul>
                <li>have your data processed in a fair, lawful and transparent way;</li>
                <li>be informed about how your personal data is being used, an example being this privacy policy;</li>
                <li>access personal data we hold about you;</li>
                <li>require us to correct any mistakes in your personal data;</li>
                <li>
                    require us to delete personal data concerning you in certain situations where there is no good
                    reason for us to continue to process it;
                </li>
                <li>
                    request that we transfer your personal data to you or another service provider in a simple,
                    structured format;
                </li>
                <li>object at any time to processing of your personal data for direct marketing purposes;</li>
                <li>
                    object to automated decision making which produces legal effects concerning you or similarly
                    significantly affects you;
                </li>
                <li>object in certain other situations to our continued processing of your personal data; and</li>
                <li>
                    otherwise restrict or temporarily stop our processing of your personal data in certain
                    circumstances.
                </li>
            </ul>
            <p>
                You can read more about your rights, including the circumstances in which they apply, in the Guidance
                from the UK Information Commissioner&apos;s Office (ICO) https://ico.org.uk/for-the-public. You also
                have the right to complain about our use of personal data to the ICO. You can do these by contacting the
                ICO via their website https://ico.org.uk/concerns or by calling 0303 123 1113.
            </p>
            <p>
                If you would like more information about your rights regarding your Personal Data, please see our
                privacy policy, available at https://www.ikea.com/gb/en/customer-service/privacy-policy/
            </p>
        </div>
        <div>
            <p>
                <strong>7. How long do we retain your information?</strong>
            </p>
            <p>
                In general, we will only retain personal information regarding your use of the Sugarcube app for as long
                as is necessary for the purposes described in this Privacy Notice. This means that the retention periods
                will vary according to the type of the information and the reason that we have the information.
            </p>
        </div>
        <div>
            <p>
                <strong>8. Changes to this Privacy Policy</strong>
            </p>
            <p>
                We may update this Privacy Notice from time to time. Please regularly check for updates. You can tell if
                the Privacy Notice has changed by checking the revision date that appears above. If we change this
                Privacy Notice in a material way, we will provide appropriate notice to you. By using our websites or
                mobile apps, you agree to accept the terms of this Privacy Notice as stated at the time you use them.
            </p>
        </div>
        <div>
            <p>
                <strong>9. Contact</strong>
            </p>
            <p>If you have any questions about this Privacy Policy or your rights under it, please contact</p>
            <p>
                Philip Cooke – IKEA UK&IE Data Protection OfficerIKEA, Customer Support Centre, Kingston Park,
                Peterborough, PE2 9ET, United Kingdom
            </p>
            <p>0203 645 0000</p>
            <p>dataprotection.officer.gb@ingka.ikea.com</p>
        </div>
    </>
)
